import { PROOF_VIDEO_TYPES, UPLOAD_CONTENT_TYPES } from '@/types/file'

export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024
export const MAX_VIDEO_BYTES = 200 * 1024 * 1024

// Documents (any stage) + the proof "Upload document" option.
export const UPLOAD_ACCEPT = 'image/jpeg,image/png,application/pdf'
// Proof "Take photo / video": photos + video only (no PDF).
export const CAMERA_ACCEPT = `image/jpeg,image/png,${PROOF_VIDEO_TYPES.join(',')}`

function isVideoType(type: string): boolean {
  return (PROOF_VIDEO_TYPES as readonly string[]).includes(type)
}

/**
 * Client-side pre-check mirroring the Storage rules. Documents/photos ≤ 25 MB;
 * proof-of-product videos (when `allowVideo`) ≤ 200 MB. Returns an error, or null.
 */
export function validateUploadFile(
  file: { type: string; size: number },
  { allowVideo = false }: { allowVideo?: boolean } = {},
): string | null {
  const docOk = (UPLOAD_CONTENT_TYPES as readonly string[]).includes(file.type)
  const videoOk = allowVideo && isVideoType(file.type)
  if (!docOk && !videoOk) {
    return allowVideo
      ? 'Only JPG, PNG, PDF or video (MP4/MOV/WebM) files are allowed.'
      : 'Only JPG, PNG and PDF files are allowed.'
  }
  if (isVideoType(file.type)) {
    if (file.size > MAX_VIDEO_BYTES) {
      return 'Video must be 200 MB or smaller.'
    }
  } else if (file.size > MAX_UPLOAD_BYTES) {
    return 'File must be 25 MB or smaller.'
  }
  return null
}
